import { TipoEntidadeEnum } from '@app/core/models/tipo-entidade.enum';

export interface Entidade {
  id: number;
  nome?: string;
  tipo: TipoEntidadeEnum;
  externo?: number;
}
